export default __webpack_public_path__ + "static/media/number-6.8cc74f45.svg";